import { Link } from '@tanstack/react-router';
import { Button, Stack, Text, Title } from '@mantine/core';

/**
 * Global not-found view — wired as the router's `defaultNotFoundComponent`
 * (see router.tsx). Renders inside the AppShell chrome via the root `<Outlet />`,
 * so the header + navbar stay usable. Shown for unknown paths and for detail
 * routes whose id fails validation (router `beforeLoad` → `notFound()`).
 */
export const NotFoundView = (): React.JSX.Element => (
    <Stack gap="md" align="flex-start" data-testid="NotFoundView">
        <Title order={2}>Page not found</Title>
        <Text c="dimmed">
            That page doesn’t exist — the URL may be mistyped or contain an invalid id.
        </Text>
        <Button component={Link} to="/catalog">
            Go to Company Catalog
        </Button>
    </Stack>
);
